'use client';

import CircularProgress from '@mui/material/CircularProgress';

import { tss } from 'tss-react/mui';

const useStyles = tss.create(({ theme }) => ({
  root: {
    display: 'flex',
    alignItems: 'center',
    flexDirection: 'column',
    textAlign: 'center',
    padding: theme.spacing(2),
    minWidth: 80,
  },
}));

export const Loading = () => {
  const { classes } = useStyles();
  return (
    <div className={classes.root}>
      <CircularProgress size={60} />
    </div>
  );
};
